import * as ENV       from '../util/env';
import * as Resources from '../util/resources';
import { Device }     from 'twilio-client';
import store          from '../store';


const device = new Device();
let devicePromise;
export async function getDevice() {
  if (devicePromise)
    return await devicePromise;

  devicePromise = updateToken();
  return await devicePromise;
}


async function getAccessToken() {
  const { body } = await store.dispatch(Resources.silentRequest({
    url: `${API_URL}/me/twilio_voice`
  }));
  return body;
}


export async function updateToken() {
  try {
    const token = await getAccessToken();
    device.setup(token, { enableRingingState: true, debug: ENV.isDevelopment() });

    if (device.status() === 'ready')
      return device;
    else
      return await new Promise(resolve => device.on('ready', () => resolve(device)));
  } catch (error) {
    throw new Error(`Error updating Twilio Voice access token: ${error.message} ${error.code}`);
  }
}
